module.exports = __webpack_public_path__ + "static/media/chlhidro.384f4412.jpg";